import { render, staticRenderFns } from "./addChangeDemand.vue?vue&type=template&id=b5955f30&scoped=true&"
import script from "./addChangeDemand.vue?vue&type=script&lang=js&"
export * from "./addChangeDemand.vue?vue&type=script&lang=js&"
import style0 from "./addChangeDemand.vue?vue&type=style&index=0&id=b5955f30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5955f30",
  null
  
)

export default component.exports